<div class="breadcrumb-component" *ngIf="breadcrumbs$ | async as list" [ngClass]="{hasOptions: actions.length > 0}">
	<div class='breadcrumb-component-titles' [ngClass]="{withBack: showBack}">
		<div class='breadcrumb-return' *ngIf="showBack">
			<a (click)="goBack()">
				<mat-icon>arrow_back</mat-icon>
			</a>
		</div>
		<div class="breadcrumb-title">
			{{ (breadcrumbsActive$ | async)?.label }}
		</div>
	
		<div class="breadcrumb-items">
			<div class="breadcrumb">
				<div class="breadcrumb-item">
					<a routerLink="/dashboard" class="breadcrumb-link" title="Página principal">
						<mat-icon>home</mat-icon>
					</a>
				</div>
				<div class="separator"></div>
			</div>
			<div class="breadcrumb" *ngFor="let breadcrumb of breadcrumbs$ | async">
				<div class="breadcrumb-item">
					<a
						class="breadcrumb-link"
						[routerLink]="breadcrumb.url"
						[title]="breadcrumb.label"
						*ngIf="!breadcrumb.disableLink"
						>{{ breadcrumb.label }}
					</a>
					<span
						class="breadcrumb-link-span text-muted"
						[title]="breadcrumb.label"
						*ngIf="breadcrumb.disableLink"
					>
					{{ breadcrumb.label }}
					</span>
				</div>
				<div class="separator"></div>
			</div>
		</div>
	</div>

	<div class="options">
		<div class="breadcrumb-actions" *ngIf="validateActions()">
			<button mat-icon-button [matMenuTriggerFor]="menuActions">
				<mat-icon>more_vert</mat-icon>
			</button>
			<mat-menu #menuActions>
				<div *ngFor="let action of actions">
					<div class='loadExcel' *ngIf="action.action === 'import_excel' && !isAdmin">
						<button
							mat-menu-item
							(click)="loadFromExcel()"
						>
							Cargar desde Excel
						</button>
						<input type="file" hidden #inputLoadExcel accept=".xls, .xlsx" (change)="excelUpload($event)" />
					</div>
					<div class='downloadDocuments'  *ngIf="action.action === 'download_all'">
						<button
							mat-menu-item
							(click)="downloadDocuments()"
						>
							Descargar todos los documentos
						</button>
					</div>
				</div>
			</mat-menu>
		</div>
		
		<div class='breadcrumb-buttons' *ngIf="buttons.length > 0">
			<button class="button-action" mat-raised-button [color]="button.color" *ngFor="let button of buttons" [routerLink]="button.link">
				{{button.name}}
			</button>
		</div>
	</div>
</div>
